module["exports"] = ["+374 ## ######", "+374 ### #####"];